/*
edlc-date-time-filters.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('modules/shell/filters/date-time-formatters/edlc-date-time-filters',['angular', 'moment-with-locales'], function (angular, moment) {
    var mod = angular.module('edlcDateTimeFormatters', []);

    var formatDateToCustomFormat = function (isUtc, getMomentDate, formatString) {
        return isUtc ? moment(getMomentDate).utc().format(formatString) : moment(getMomentDate).format(formatString);
    };

    var formatDateToJapaneseFormat = function (isUtc, isDateWithTime, getMomentDate) {
        if(isUtc) {
            return isDateWithTime ? moment(getMomentDate).utc().format('LLL') : moment(getMomentDate).utc().format('LL');
        } else {
            return isDateWithTime ? moment(getMomentDate).format('LLL') : moment(getMomentDate).format('LL');
        }
    };

    var formatDateToInternationalFormat = function (isUtc, isDateWithTime, getMomentDate) {
        if(isUtc) {
            return isDateWithTime ? moment(getMomentDate).utc().format('DD MMM YYYY HH:mm') : moment(getMomentDate).utc().format('DD MMM YYYY');
        } else {
            return isDateWithTime ? moment(getMomentDate).format('DD MMM YYYY HH:mm') : moment(getMomentDate).format('DD MMM YYYY');
        }
    };

    var formatDate = function (date, $translate, isDateWithTime, isUtc, formatString) {
        if (!date || date === '') {
            return null;
        }
        var locale = $translate.use();
        var getMomentDate;
        moment.locale(locale);

        if(moment(date).isValid()) {
            getMomentDate = moment(date);
        } else if(moment(date, ['LLL', 'LL', 'DD M- YYYY']).isValid()) {
            getMomentDate = moment(date, ['LLL', 'LL', 'DD M- YYYY']);
        } else if(moment(date, 'x').isValid()) {
            getMomentDate = moment(date, 'x');
        } else {
            return date;
        }
        if (formatString) {
            return formatDateToCustomFormat(isUtc, getMomentDate, formatString);
        } else {
            return locale === 'ja' ? formatDateToJapaneseFormat(isUtc, isDateWithTime, getMomentDate, formatString) : formatDateToInternationalFormat(isUtc, isDateWithTime, getMomentDate, formatString);
        }
    };

    var edlcDateFormatter = function ($translate) {
        return function (date, formatString) {
            return formatDate(date, $translate, false, false, formatString);
        };
    };

    var edlcDateTimeFormatter = function ($translate) {
        return function (date, formatString) {
            return formatDate(date, $translate, true, false, formatString);
        };
    };
    var edlcDateFormatterUtc = function ($translate) {
        return function (date, formatString) {
            return formatDate(date, $translate, false, true, formatString);
        };
    };
    var edlcDateTimeFormatterUtc = function ($translate) {
        return function (date, formatString) {
            return formatDate(date, $translate, true, true, formatString);
        };
    };

    mod.filter('edlcDateFormatter', ['$translate', edlcDateFormatter]);
    mod.filter('edlcDateTimeFormatter', ['$translate', edlcDateTimeFormatter]);
    mod.filter('edlcDateFormatterUtc', ['$translate', edlcDateFormatterUtc]);
    mod.filter('edlcDateTimeFormatterUtc', ['$translate', edlcDateTimeFormatterUtc]);
});

